<app-confirmation-modal
 content="This feedback will be deleted. Please confirm the selection."
 modalHeading="Are you sure you want to delete this feedback?"
 buttonText="Delete"
 [request$]="request$()"
 toasterText="Feedback deleted"
 >

</app-confirmation-modal>